"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CollectionEventType = _interopRequireDefault(require("../CollectionEventType.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _GeometryType = _interopRequireDefault(require("../geom/GeometryType.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _RBush = _interopRequireDefault(require("../structs/RBush.js"));

var _VectorEventType = _interopRequireDefault(require("../source/VectorEventType.js"));

var _functions = require("../functions.js");

var _extent = require("../extent.js");

var _coordinate = require("../coordinate.js");

var _Polygon = require("../geom/Polygon.js");

var _proj = require("../proj.js");

var _util = require("../util.js");

var _obj = require("../obj.js");

var _events = require("../events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Snap
 */


/**
 * @typedef {Object} Result
 * @property {import("../coordinate.js").Coordinate|null} vertex Vertex.
 * @property {import("../pixel.js").Pixel|null} vertexPixel VertexPixel.
 */

/**
 * @typedef {Object} SegmentData
 * @property {import("../Feature.js").default} feature Feature.
 * @property {Array<import("../coordinate.js").Coordinate>} segment Segment.
 */

/**
 * @typedef {Object} Options
 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features] Snap to these features. Either this option or source should be provided.
 * @property {boolean} [edge=true] Snap to edges.
 * @property {boolean} [vertex=true] Snap to vertices.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the pointer close enough to a segment or
 * vertex for snapping.
 * @property {import("../source/Vector.js").default} [source] Snap to features from this source. Either this option or features should be provided
 */

/**
 * @param  {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
 * @return {import("../Feature.js").default} Feature.
 */
function getFeatureFromEvent(evt) {
  if (
  /** @type {import("../source/Vector.js").VectorSourceEvent} */
  evt.feature) {
    return (
      /** @type {import("../source/Vector.js").VectorSourceEvent} */
      evt.feature
    );
  } else if (
  /** @type {import("../Collection.js").CollectionEvent} */
  evt.element) {
    return (
      /** @type {import("../Feature.js").default} */

      /** @type {import("../Collection.js").CollectionEvent} */
      evt.element
    );
  }
}

var tempSegment = [];
/**
 * @classdesc
 * Handles snapping of vector features while modifying or drawing them.  The
 * features can come from a {@link module:ol/source/Vector~VectorSource} or {@link module:ol/Collection~Collection}
 * Any interaction object that allows the user to interact
 * with the features using the mouse can benefit from the snapping, as long
 * as it is added before.
 *
 * The snap interaction modifies map browser event `coordinate` and `pixel`
 * properties to force the snap to occur to any interaction that them.
 *
 * Example:
 *
 *     import Snap from 'ol/interaction/Snap';
 *
 *     const snap = new Snap({
 *       source: source
 *     });
 *
 *     map.addInteraction(snap);
 *
 * @api
 */

var Snap =
/** @class */
function (_super) {
  __extends(Snap, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Snap(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var pointerOptions =
    /** @type {import("./Pointer.js").Options} */
    options;

    if (!pointerOptions.handleDownEvent) {
      pointerOptions.handleDownEvent = _functions.TRUE;
    }

    if (!pointerOptions.stopDown) {
      pointerOptions.stopDown = _functions.FALSE;
    }

    _this = _super.call(this, pointerOptions) || this;
    /**
     * @type {import("../source/Vector.js").default|null}
     * @private
     */

    _this.source_ = options.source ? options.source : null;
    /**
     * @private
     * @type {boolean}
     */

    _this.vertex_ = options.vertex !== undefined ? options.vertex : true;
    /**
     * @private
     * @type {boolean}
     */

    _this.edge_ = options.edge !== undefined ? options.edge : true;
    /**
     * @type {import("../Collection.js").default<import("../Feature.js").default>|null}
     * @private
     */

    _this.features_ = options.features ? options.features : null;
    /**
     * @type {Array<import("../events.js").EventsKey>}
     * @private
     */

    _this.featuresListenerKeys_ = [];
    /**
     * @type {Object<string, import("../events.js").EventsKey>}
     * @private
     */

    _this.featureChangeListenerKeys_ = {};
    /**
     * Extents are preserved so indexed segment can be quickly removed
     * when its feature geometry changes
     * @type {Object<string, import("../extent.js").Extent>}
     * @private
     */

    _this.indexedFeaturesExtents_ = {};
    /**
     * If a feature geometry changes while a pointer drag|move event occurs, the
     * feature doesn't get updated right away.  It will be at the next 'pointerup'
     * event fired.
     * @type {!Object<string, import("../Feature.js").default>}
     * @private
     */

    _this.pendingFeatures_ = {};
    /**
     * @type {number}
     * @private
     */

    _this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
    /**
     * Segment RTree for each layer
     * @type {import("../structs/RBush.js").default<SegmentData>}
     * @private
     */

    _this.rBush_ = new _RBush["default"]();
    /**
     * @const
     * @private
     * @type {Object<string, function(Array<Array<import('../coordinate.js').Coordinate>>, import("../geom/Geometry.js").default): void>}
     */

    _this.GEOMETRY_SEGMENTERS_ = {
      'Point': _this.segmentPointGemetry_.bind(_this),
      'LineString': _this.segmentLineStringGemetry_.bind(_this),
      'LinearRing': _this.segmentLineStringGemetry_.bind(_this),
      'Polygon': _this.segmentPolygonGemetry_.bind(_this),
      'MultiPoint': _this.segmentMultiPointGemetry_.bind(_this),
      'MultiLineString': _this.segmentMultiLineStringGemetry_.bind(_this),
      'MultiPolygon': _this.segmentMultiPolygonGemetry_.bind(_this),
      'GeometryCollection': _this.segmentGeometryCollectionGemetry_.bind(_this),
      'Circle': _this.segmentCircleGemetry_.bind(_this)
    };
    return _this;
  }
  /**
   * Add a feature to the collection of features that we may snap to.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {boolean} [opt_listen] Whether to listen to the feature change or not
   *     Defaults to `true`.
   * @api
   */


  Snap.prototype.addFeature = function (feature, opt_listen) {
    var register = opt_listen !== undefined ? opt_listen : true;
    var feature_uid = (0, _util.getUid)(feature);
    var geometry = feature.getGeometry();

    if (geometry) {
      var segmenter = this.GEOMETRY_SEGMENTERS_[geometry.getType()];

      if (segmenter) {
        this.indexedFeaturesExtents_[feature_uid] = geometry.getExtent((0, _extent.createEmpty)());
        var segments =
        /** @type {Array<Array<import('../coordinate.js').Coordinate>>} */
        [];
        segmenter(segments, geometry);

        if (segments.length === 1) {
          this.rBush_.insert((0, _extent.boundingExtent)(segments[0]), {
            feature: feature,
            segment: segments[0]
          });
        } else if (segments.length > 1) {
          var extents = segments.map(function (s) {
            return (0, _extent.boundingExtent)(s);
          });
          var segmentsData = segments.map(function (segment) {
            return {
              feature: feature,
              segment: segment
            };
          });
          this.rBush_.load(extents, segmentsData);
        }
      }
    }

    if (register) {
      this.featureChangeListenerKeys_[feature_uid] = (0, _events.listen)(feature, _EventType["default"].CHANGE, this.handleFeatureChange_, this);
    }
  };
  /**
   * @param {import("../Feature.js").default} feature Feature.
   * @private
   */


  Snap.prototype.forEachFeatureAdd_ = function (feature) {
    this.addFeature(feature);
  };
  /**
   * @param {import("../Feature.js").default} feature Feature.
   * @private
   */


  Snap.prototype.forEachFeatureRemove_ = function (feature) {
    this.removeFeature(feature);
  };
  /**
   * @return {import("../Collection.js").default<import("../Feature.js").default>|Array<import("../Feature.js").default>} Features.
   * @private
   */


  Snap.prototype.getFeatures_ = function () {
    var features;

    if (this.features_) {
      features = this.features_;
    } else if (this.source_) {
      features = this.source_.getFeatures();
    }

    return features;
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */


  Snap.prototype.handleEvent = function (evt) {
    var result = this.snapTo(evt.pixel, evt.coordinate, evt.map);

    if (result) {
      evt.coordinate = result.vertex.slice(0, 2);
      evt.pixel = result.vertexPixel;
    }

    return _super.prototype.handleEvent.call(this, evt);
  };
  /**
   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Snap.prototype.handleFeatureAdd_ = function (evt) {
    var feature = getFeatureFromEvent(evt);
    this.addFeature(feature);
  };
  /**
   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Snap.prototype.handleFeatureRemove_ = function (evt) {
    var feature = getFeatureFromEvent(evt);
    this.removeFeature(feature);
  };
  /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */


  Snap.prototype.handleFeatureChange_ = function (evt) {
    var feature =
    /** @type {import("../Feature.js").default} */
    evt.target;

    if (this.handlingDownUpSequence) {
      var uid = (0, _util.getUid)(feature);

      if (!(uid in this.pendingFeatures_)) {
        this.pendingFeatures_[uid] = feature;
      }
    } else {
      this.updateFeature_(feature);
    }
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   */


  Snap.prototype.handleUpEvent = function (evt) {
    var featuresToUpdate = (0, _obj.getValues)(this.pendingFeatures_);

    if (featuresToUpdate.length) {
      featuresToUpdate.forEach(this.updateFeature_.bind(this));
      this.pendingFeatures_ = {};
    }

    return false;
  };
  /**
   * Remove a feature from the collection of features that we may snap to.
   * @param {import("../Feature.js").default} feature Feature
   * @param {boolean} [opt_unlisten] Whether to unlisten to the feature change
   *     or not. Defaults to `true`.
   * @api
   */


  Snap.prototype.removeFeature = function (feature, opt_unlisten) {
    var unregister = opt_unlisten !== undefined ? opt_unlisten : true;
    var feature_uid = (0, _util.getUid)(feature);
    var extent = this.indexedFeaturesExtents_[feature_uid];

    if (extent) {
      var rBush = this.rBush_;
      var nodesToRemove_1 = [];
      rBush.forEachInExtent(extent, function (node) {
        if (feature === node.feature) {
          nodesToRemove_1.push(node);
        }
      });

      for (var i = nodesToRemove_1.length - 1; i >= 0; --i) {
        rBush.remove(nodesToRemove_1[i]);
      }
    }

    if (unregister) {
      (0, _events.unlistenByKey)(this.featureChangeListenerKeys_[feature_uid]);
      delete this.featureChangeListenerKeys_[feature_uid];
    }
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  Snap.prototype.setMap = function (map) {
    var currentMap = this.getMap();
    var keys = this.featuresListenerKeys_;
    var features =
    /** @type {Array<import("../Feature.js").default>} */
    this.getFeatures_();

    if (currentMap) {
      keys.forEach(_events.unlistenByKey);
      keys.length = 0;
      features.forEach(this.forEachFeatureRemove_.bind(this));
    }

    _super.prototype.setMap.call(this, map);

    if (map) {
      if (this.features_) {
        keys.push((0, _events.listen)(this.features_, _CollectionEventType["default"].ADD, this.handleFeatureAdd_, this), (0, _events.listen)(this.features_, _CollectionEventType["default"].REMOVE, this.handleFeatureRemove_, this));
      } else if (this.source_) {
        keys.push((0, _events.listen)(this.source_, _VectorEventType["default"].ADDFEATURE, this.handleFeatureAdd_, this), (0, _events.listen)(this.source_, _VectorEventType["default"].REMOVEFEATURE, this.handleFeatureRemove_, this));
      }

      features.forEach(this.forEachFeatureAdd_.bind(this));
    }
  };
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel
   * @param {import("../coordinate.js").Coordinate} pixelCoordinate Coordinate
   * @param {import("../PluggableMap.js").default} map Map.
   * @return {Result|null} Snap result
   */


  Snap.prototype.snapTo = function (pixel, pixelCoordinate, map) {
    var lowerLeft = map.getCoordinateFromPixel([pixel[0] - this.pixelTolerance_, pixel[1] + this.pixelTolerance_]);
    var upperRight = map.getCoordinateFromPixel([pixel[0] + this.pixelTolerance_, pixel[1] - this.pixelTolerance_]);
    var box = (0, _extent.boundingExtent)([lowerLeft, upperRight]);
    var segments = this.rBush_.getInExtent(box);
    var segmentsLength = segments.length;

    if (segmentsLength === 0) {
      return null;
    }

    var projection = map.getView().getProjection();
    var projectedCoordinate = (0, _proj.fromUserCoordinate)(pixelCoordinate, projection);
    var closestVertex;
    var minSquaredDistance = Infinity;
    var squaredPixelTolerance = this.pixelTolerance_ * this.pixelTolerance_;

    var getResult = function getResult() {
      if (closestVertex) {
        var vertexPixel = map.getPixelFromCoordinate(closestVertex);
        var squaredPixelDistance = (0, _coordinate.squaredDistance)(pixel, vertexPixel);

        if (squaredPixelDistance <= squaredPixelTolerance) {
          return {
            vertex: closestVertex,
            vertexPixel: [Math.round(vertexPixel[0]), Math.round(vertexPixel[1])]
          };
        }
      }

      return null;
    };

    if (this.vertex_) {
      for (var i = 0; i < segmentsLength; ++i) {
        var segmentData = segments[i];

        if (segmentData.feature.getGeometry().getType() !== _GeometryType["default"].CIRCLE) {
          segmentData.segment.forEach(function (vertex) {
            var tempVertexCoord = (0, _proj.fromUserCoordinate)(vertex, projection);
            var delta = (0, _coordinate.squaredDistance)(projectedCoordinate, tempVertexCoord);

            if (delta < minSquaredDistance) {
              closestVertex = vertex;
              minSquaredDistance = delta;
            }
          });
        }
      }

      var result = getResult();

      if (result) {
        return result;
      }
    }

    if (this.edge_) {
      for (var i = 0; i < segmentsLength; ++i) {
        var vertex = null;
        var segmentData = segments[i];

        if (segmentData.feature.getGeometry().getType() === _GeometryType["default"].CIRCLE) {
          var circleGeometry = segmentData.feature.getGeometry();
          var userProjection = (0, _proj.getUserProjection)();

          if (userProjection) {
            circleGeometry = circleGeometry.clone().transform(userProjection, projection);
          }

          vertex = (0, _proj.toUserCoordinate)((0, _coordinate.closestOnCircle)(projectedCoordinate,
          /** @type {import("../geom/Circle.js").default} */
          circleGeometry), projection);
        } else {
          var _a = segmentData.segment,
              segmentStart = _a[0],
              segmentEnd = _a[1]; // points have only one coordinate

          if (segmentEnd) {
            tempSegment[0] = (0, _proj.fromUserCoordinate)(segmentStart, projection);
            tempSegment[1] = (0, _proj.fromUserCoordinate)(segmentEnd, projection);
            vertex = (0, _coordinate.closestOnSegment)(projectedCoordinate, tempSegment);
          }
        }

        if (vertex) {
          var delta = (0, _coordinate.squaredDistance)(projectedCoordinate, vertex);

          if (delta < minSquaredDistance) {
            closestVertex = vertex;
            minSquaredDistance = delta;
          }
        }
      }

      var result = getResult();

      if (result) {
        return result;
      }
    }

    return null;
  };
  /**
   * @param {import("../Feature.js").default} feature Feature
   * @private
   */


  Snap.prototype.updateFeature_ = function (feature) {
    this.removeFeature(feature, false);
    this.addFeature(feature, false);
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentCircleGemetry_ = function (segments, geometry) {
    var projection = this.getMap().getView().getProjection();
    var circleGeometry = geometry;
    var userProjection = (0, _proj.getUserProjection)();

    if (userProjection) {
      circleGeometry =
      /** @type {import("../geom/Circle.js").default} */
      circleGeometry.clone().transform(userProjection, projection);
    }

    var polygon = (0, _Polygon.fromCircle)(circleGeometry);

    if (userProjection) {
      polygon.transform(projection, userProjection);
    }

    var coordinates = polygon.getCoordinates()[0];

    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
      segments.push(coordinates.slice(i, i + 2));
    }
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentGeometryCollectionGemetry_ = function (segments, geometry) {
    var geometries = geometry.getGeometriesArray();

    for (var i = 0; i < geometries.length; ++i) {
      var segmenter = this.GEOMETRY_SEGMENTERS_[geometries[i].getType()];

      if (segmenter) {
        segmenter(segments, geometries[i]);
      }
    }
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentLineStringGemetry_ = function (segments, geometry) {
    var coordinates = geometry.getCoordinates();

    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
      segments.push(coordinates.slice(i, i + 2));
    }
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentMultiLineStringGemetry_ = function (segments, geometry) {
    var lines = geometry.getCoordinates();

    for (var j = 0, jj = lines.length; j < jj; ++j) {
      var coordinates = lines[j];

      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        segments.push(coordinates.slice(i, i + 2));
      }
    }
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentMultiPointGemetry_ = function (segments, geometry) {
    geometry.getCoordinates().forEach(function (point) {
      segments.push([point]);
    });
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentMultiPolygonGemetry_ = function (segments, geometry) {
    var polygons = geometry.getCoordinates();

    for (var k = 0, kk = polygons.length; k < kk; ++k) {
      var rings = polygons[k];

      for (var j = 0, jj = rings.length; j < jj; ++j) {
        var coordinates = rings[j];

        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
          segments.push(coordinates.slice(i, i + 2));
        }
      }
    }
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/Point.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentPointGemetry_ = function (segments, geometry) {
    segments.push([geometry.getCoordinates()]);
  };
  /**
   * @param {Array<Array<import('../coordinate.js').Coordinate>>} segments Segments
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */


  Snap.prototype.segmentPolygonGemetry_ = function (segments, geometry) {
    var rings = geometry.getCoordinates();

    for (var j = 0, jj = rings.length; j < jj; ++j) {
      var coordinates = rings[j];

      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        segments.push(coordinates.slice(i, i + 2));
      }
    }
  };

  return Snap;
}(_Pointer["default"]);

var _default = Snap;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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